<template>
  <router-link :to="target" @click="$emit('click')" class="-m-3 p-3 block rounded-md transition ease-in-out duration-150 hover:bg-indigo-50">
    <p class="text-base leading-6 font-medium text-gray-900 m-0" :class="titleClass">
      {{ title }}
    </p>
    <p class="text-sm leading-5 text-gray-500 m-0">
      <!-- @slot Let's you pass a string or html as the menu item's description. -->
      <slot />
    </p>
  </router-link>
</template>

<script>
export default {
  props: {
    /**
     * Used to specify the menu's title.
     */
    title: {
      type: String,
      default: 'Link Title'
    },
    /**
     * Specify CSS classes to apply to the title (like a color or uppercase).
     */
    titleClass: {
      type: String,
      default: ''
    },
    /**
     * Sets the URL for this menu item.
     */
    target: {
      type: String,
      default: '/'
    }
  },
  emits: ['click']
}
</script>

<style></style>
